export class PluginData {
  static DISPLAY_MODES = {
    WINDOWED: 'WINDOWED',
    FULLSCREEN: 'FULLSCREEN'
  };

  static PLUGIN_TYPES = {
    WEB: 'WEB',
    LINK: 'LINK',
    DESKTOP: 'DESKTOP'
  };

  constructor(data) {
    this.plugin_id = data.plugin_id;
    this.name = data.name || '';
    this.category = data.category || '';
    this.url = data.url;
    this.main_branch = data.main_branch;
    this.beta_branch = data.beta_branch || null;
    this.enabled = data.enabled ?? true;
    this.display_order = data.display_order;
    this.description = data.description || '';
    this.author = data.author || '';
    this.wiki_url = data.wiki_url || null;
    this.plugin_type = data.plugin_type;
    this.display_mode = PluginData.normalizeDisplayMode(data.display_mode);
    this.thumbnail_url = data.thumbnail_url || null;
    this.thumbnail_updated_at = data.thumbnail_updated_at || null;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.space_ids = data.space_ids || [];  // Space assignments
  }

  static normalizeDisplayMode(mode) {
    if (!mode) return PluginData.DISPLAY_MODES.WINDOWED;
    
    const upperMode = mode.toUpperCase();
    return upperMode === PluginData.DISPLAY_MODES.FULLSCREEN 
      ? PluginData.DISPLAY_MODES.FULLSCREEN 
      : PluginData.DISPLAY_MODES.WINDOWED;
  }

  get isFullscreen() {
    return this.display_mode === PluginData.DISPLAY_MODES.FULLSCREEN;
  }

  get isWindowed() {
    return this.display_mode === PluginData.DISPLAY_MODES.WINDOWED;
  }

  get isWeb() { 
    return this.plugin_type === PluginData.PLUGIN_TYPES.WEB; 
  }
  
  get isLink() { 
    return this.plugin_type === PluginData.PLUGIN_TYPES.LINK; 
  }
  
  get isDesktop() { 
    return this.plugin_type === PluginData.PLUGIN_TYPES.DESKTOP; 
  }

  static fromApiResponse(data) {
    const validatedData = {
      ...data,
      display_mode: PluginData.normalizeDisplayMode(data.display_mode)
    };
    return new PluginData(validatedData);
  }

  static fromApiResponseList(dataList = []) {
    return dataList.map(PluginData.fromApiResponse);
  }

  toApiFormat() {
    return {
      plugin_id: this.plugin_id,
      name: this.name,
      category: this.category,
      url: this.url,
      main_branch: this.main_branch,
      beta_branch: this.beta_branch,
      enabled: this.enabled,
      display_order: this.display_order,
      description: this.description,
      author: this.author,
      wiki_url: this.wiki_url,
      plugin_type: this.plugin_type,
      display_mode: this.display_mode
    };
  }

  getDisplayModeForUI() {
    return this.display_mode.toLowerCase();
  }
}